import React from 'react';
import {
  withStyles,
  MenuItem,
  Divider,
  MenuItemProps,
} from '@material-ui/core';

export const StyledMenuItem = withStyles(({ spacing, palette }) => ({
  root: {
    padding: spacing(2.5),
    borderRadius: spacing(1),
    transition: `background-color .3s ease-in-out`,
    '& svg': {
      marginRight: spacing(3),
    },
    '& svg [stroke]': {
      transition: `stroke .3s ease-in-out`,
      stroke: palette.grey[300],
    },
    '& svg.MuiSvgIcon-root :is(path, circle)': {
      transition: `fill .3s ease-in-out`,
      fill: palette.grey[300],
    },
    '& .MuiTypography-root': {
      transition: `color .3s ease-in-out`,
      color: palette.grey[400],
    },
    '&.Mui-selected': {
      backgroundColor: palette.primary.main,
      '&:hover': {
        backgroundColor: palette.primary.main,
      },
      '& svg [stroke]': {
        stroke: palette.common.white,
      },
      '& svg [path]': {
        fill: `palette.common.white !important`,
      },
      '& svg.MuiSvgIcon-root :is(path, circle)': {
        fill: palette.common.white,
      },
      '& .MuiTypography-root': {
        color: palette.common.white,
      },
    },
  },
}))((props: MenuItemProps & { component: React.ElementType; to: string }) => (
  <MenuItem {...props} button />
));

export const StyledDivider = withStyles(({ spacing }) => ({
  root: {
    margin: spacing(1, 0),
  },
}))(Divider);
